import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import LineChart from "./LineChart";
import I18n from "i18n-js";
import { Chart } from "chart.js";
import { generateRandomNumber } from "../../utils/utils";

const BlueprintImageFlowMarketModal = ({
   marketFlow,
   showMarketFlow,
   setShowMarketFlow
  }) => {


  const skipped = (ctx, value) => ctx.p0.skip || ctx.p1.skip ? value : undefined;
  const down = (ctx, value) => ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;
  
  const [ initCompleted, setInitCompleted ] = useState(false)
  const [ datasets, setDatasets ] = useState([])
  const [ labels, setLabels ] = useState([])
  const [ legend, setLegend ] = useState({})

  const handleCloseFlowMarketModal = () => {
    setShowMarketFlow(false)
  }

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true);

      const datasetsToRender = [];
      const labelsToRender = [];
      const legendToRender = {};
      
      for (let i = 0; i < marketFlow.length; i++) {
        if (i === 0)
          labelsToRender.push(marketFlow[0][1][0])

        const r = generateRandomNumber(0, 250)
        const g = generateRandomNumber(0, 250)
        const b = generateRandomNumber(0, 250)
        const rgb = `rgb(${r},${g},${b})`

        legendToRender[parseGrading(marketFlow[i][0])] = { color: rgb, hide: true }

        datasetsToRender.push(
          {
            label: 'Grading: ' + parseGrading(marketFlow[i][0]),
            fontWeight: "bold",
            data: marketFlow[i][1][1],
            borderColor: [ rgb ],
            segment: {
              borderColor: ctx => skipped(ctx, rgb) || down(ctx, rgb),
              borderDash: ctx => skipped(ctx, [0, 0]),
            },
            borderWidth: 2,
            fill: false,
            cubicInterpolationMode: 'monotone',
            tension: 0.4
          }
        )
      }

      setLegend(legendToRender)
      setDatasets(datasetsToRender)
      setLabels(labelsToRender)
    }
  }, []);


  // Funzione che formatta il grading da renderizzare a video
  const parseGrading = (grade) => {
    return (grade.toString().indexOf('.0') > -1 ? grade.toString().replace('.0', '') : grade.toString())
  }


  // Funzione che si occupa di mostrare / nascondere dal grafico l'andamento di mercato del valore della carta nel
  // tempo specificatamente a un certo grading
  const showHideDataset = (grade) => {
    const showHide = legend[grade].hide ? 'hide' : 'show'
    const legendToRender = { ...legend };
    legendToRender[grade] = { color: legend[grade].color, hide: !legend[grade].hide }
    
    if (showHide === 'hide') {
      const datasetsToRender = [];
      for (let i = 0; i < datasets.length; i++)
        if (datasets[i].label !== ("Grading: " + grade))
          datasetsToRender.push({ ...datasets[i] });
      setDatasets(datasetsToRender)

    } else if (showHide === 'show') {
      const datasetsToRender = [...datasets];
      for (let i = 0; i < marketFlow.length; i++)
        if (parseGrading(marketFlow[i][0]) === grade)
          datasetsToRender.push(
            {
              label: "Grading: " + parseGrading(marketFlow[i][0]),
              fontWeight: "bold",
              data: marketFlow[i][1][1],
              borderColor: [legend[grade].color],
              segment: {
                borderColor: ctx => skipped(ctx, legend[grade].color) || down(ctx, legend[grade].color),
                borderDash: ctx => skipped(ctx, [0, 0])
              },
              borderWidth: 2
            }
          );
      setDatasets(datasetsToRender)
    }

    setLegend(legendToRender)
  }

  return <Modal show={showMarketFlow} onHide={handleCloseFlowMarketModal} animation={false} size="lg">
    <Modal.Header closeButton >
      <Modal.Title className="mt-1">
        {I18n.t('js.marketChart.marketValue')}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <LineChart datasets={datasets} labels={labels} id={'chart_1'} />
      <div className="d-flex justify-content-start mt-5">
        <h4>{I18n.t('js.marketChart.gradings')}</h4>
      </div>
      <div className="d-flex justify-content-center mt-3">
        {
          Object.keys(legend).map((key) => {
            return <div className="mr-2 ml-2 cursor-pointer"
                        key={key}
                        style={{ color: legend[key].color }}
                        onClick={(e) => showHideDataset(key) }>
              <b>{key}</b>
              {
                legend[key].hide ?
                  <i className="fas fa-fw fa-eye ml-1" aria-hidden="true" />
                :
                  <i className="fas fa-fw fa-eye-slash ml-1" aria-hidden="true" />
              }
            </div>
          })
        }
      </div>
    </Modal.Body>
  </Modal>
}

export default BlueprintImageFlowMarketModal;